import { render } from "./navbarComponent.vue?vue&type=template&id=f53d18e0&scoped=true"
import script from "./navbarComponent.vue?vue&type=script&lang=js"
export * from "./navbarComponent.vue?vue&type=script&lang=js"

import "./navbarComponent.vue?vue&type=style&index=0&id=f53d18e0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f53d18e0"]])

export default __exports__